import React, { useEffect, useState } from "react";
import { saveTokens } from "../../utils/authTokens";
import { useUser } from '../../contexts/UserContext.tsx';
import { useNavigate } from 'react-router-dom';
import Loader from "../loader/Loader.tsx";
import { useToast } from "../toast/ToastProvider.tsx";
// import { redirectUri } from "utils/auth";

const Callback: React.FC = () => {

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { login } = useUser();
  const showToast  = useToast();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (!code || !state) {
      console.error("❌ Missing code or state in the URL");
      return;
    }

    // Find the stored login state and extract the code_verifier
    const storageKey = Object.keys(localStorage).find((key) => {
      const item = localStorage.getItem(key);
      return key.startsWith("oidc.") && item && item.includes(state);
    });

    if (!storageKey) {
      console.error("❌ No matching state found in localStorage");
      return;
    }

    const storedDataRaw = localStorage.getItem(storageKey);
    if (!storedDataRaw) {
      console.error("❌ Stored state found but no data in localStorage");
      return;
    }

    let storedData: any;
    try {
      storedData = JSON.parse(storedDataRaw);
    } catch (e) {
      console.error("❌ Failed to parse stored state data");
      return;
    }

    const codeVerifier = storedData?.code_verifier;

    if (!codeVerifier) {
      console.error("❌ Missing code_verifier");
      return;
    }

    const tokenEndpoint = process.env.REACT_APP_AUTH_URL+"/authserver/oauth2/token";
    const clientId = "login-client";
    const clientSecret = "abc"; // ⚠️ This should not be on client in production

    const basicAuth = btoa(`${clientId}:${clientSecret}`);

    fetch(tokenEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${basicAuth}`,
      },
      body: new URLSearchParams({
        grant_type: "authorization_code",
        code,
        redirect_uri: process.env.REACT_APP_REDIRECT_URI || "",
        code_verifier: codeVerifier,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Token exchange failed");
        return res.json();
      })
      .then((data) => {
        console.log("duiahefuiwa",data);
        console.log("✅ Access Token:", data.access_token);
        console.log("✅ Refresh Token:", data.refresh_token);

        saveTokens(data.access_token, data.refresh_token);

        localStorage.removeItem(storageKey);
        login(
          {
            accessToken: data.access_token,
            refreshToken: data.refresh_token
          }
        );


          setLoading(false);
        navigate("/defineui/assigned-studies", { replace: true });
        showToast.success("Login successful");
      })
      .catch((err) => {
        console.error("❌ Token error:", err);
        setLoading(false);
      });
  }, []);

  return (


    <>
    <Loader size="lg" text="Processing login..." />
    </>


    // <div className="min-h-screen flex items-center justify-center bg-gray-100">
    //   <div className="w-full max-w-sm bg-white p-8 rounded-xl shadow-md flex items-center justify-center flex-col gap-4">
    //     <svg
    //       className="animate-spin h-8 w-8 text-blue-600"
    //       xmlns="http://www.w3.org/2000/svg"
    //       fill="none"
    //       viewBox="0 0 24 24"
    //     >
    //       <circle
    //         className="opacity-25"
    //         cx="12"
    //         cy="12"
    //         r="10"
    //         stroke="currentColor"
    //         strokeWidth="4"
    //       ></circle>
    //       <path
    //         className="opacity-75"
    //         fill="currentColor"
    //         d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    //       ></path>
    //     </svg>
    //     <p className="text-gray-800 text-sm font-medium">Processing login...</p>
    //   </div>
    // </div>
  );
};

export default Callback;
